<template>
  <div class="contact-page white-theme">
    <div class="container">
      <div class="page-header text-center">
        <span class="section-tag">{{ $t('contact.tag') }}</span>
        <h1 class="section-title">{{ $t('contact.title') }}</h1>
        <p class="section-subtitle">{{ $t('contact.subtitle') }}</p>
      </div>
      <div class="contact-card">
        <p class="contact-label">{{ $t('contact.emailLabel') }}</p>
        <a class="contact-email" href="mailto:miral_support@miralvis.com">miral_support@miralvis.com</a>
        <p class="contact-hint">{{ $t('contact.hint') }}</p>
        <a href="mailto:miral_support@miralvis.com" class="btn btn-primary">{{ $t('contact.cta') }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact'
}
</script>

<style scoped>
.contact-page { padding: 48px 0 72px; }
.contact-card {
  max-width: 480px;
  margin: 0 auto;
  padding: 32px 28px;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  background: #fff;
  text-align: center;
}
.contact-label {
  margin: 0 0 8px;
  font-size: 13px;
  color: #8b8fa3;
}
.contact-email {
  display: inline-block;
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 600;
  color: #059669;
  text-decoration: none;
}
.contact-email:hover { text-decoration: underline; }
.contact-info,
.contact-hint {
  margin: 0 0 20px;
  font-size: 14px;
  color: #6b7280;
  line-height: 1.6;
}
</style>